var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import usePreviousPage from './helpers/hooks/usePreviousPage';
import { store, useAppDispatch, useAppSelector } from '../../store';
import { createSelector } from '@reduxjs/toolkit';
import { setWhiteboardCurrentPage } from '../../store/slices/whiteboard';
import { useTranslation } from 'react-i18next';
import { broadcastCurrentPageNumber } from './helpers/handleRequestedWhiteboardData';
import sendAPIRequest from '../../helpers/api/plugNmeetAPI';
import { toast } from 'react-toastify';
import { CommonResponse, SwitchPresenterReq, SwitchPresenterTask, } from '../../helpers/proto/plugnmeet_common_api_pb';
import usePreviousFileId from './helpers/hooks/usePreviousFileId';
import { displaySavedPageData, savePageData } from './helpers/utils';
const totalPagesSelector = createSelector(_react_refresh_temp_1 = (state) => state.whiteboard, (whiteboard) => whiteboard.totalPages);
$RefreshReg$(_react_refresh_temp_1, "totalPagesSelector$createSelector");
const currentPageSelector = createSelector(_react_refresh_temp_2 = (state) => state.whiteboard, (whiteboard) => whiteboard.currentPage);
$RefreshReg$(_react_refresh_temp_2, "currentPageSelector$createSelector");
const currentWhiteboardOfficeFileIdSelector = createSelector(_react_refresh_temp_3 = (state) => state.whiteboard, (whiteboard) => whiteboard.currentWhiteboardOfficeFileId);
$RefreshReg$(_react_refresh_temp_3, "currentWhiteboardOfficeFileIdSelector$createSelector");
const FooterUI = ({ excalidrawAPI, isPresenter }) => {
    var _a;
    _react_refresh_temp_6();
    const totalPages = useAppSelector(totalPagesSelector);
    const currentPage = useAppSelector(currentPageSelector);
    const currentWhiteboardOfficeFileId = useAppSelector(currentWhiteboardOfficeFileIdSelector);
    const previousFileId = usePreviousFileId(currentWhiteboardOfficeFileId);
    const [options, setOptions] = useState();
    const [disablePre, setDisablePre] = useState(true);
    const [disableNext, setDisableNext] = useState(false);
    const previousPage = usePreviousPage(currentPage);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const currentUser = store.getState().session.currentUser;
    const isAdmin = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.metadata) === null || _a === void 0 ? void 0 : _a.is_admin;
    const isRecorder = currentUser === null || currentUser === void 0 ? void 0 : currentUser.isRecorder;
    useEffect(() => {
        if (previousPage && currentPage !== previousPage && excalidrawAPI) {
            savePreviousPageData();
        }
    }, [currentPage, previousPage, excalidrawAPI]);
    useEffect(() => {
        if (currentPage > 1) {
            setDisablePre(false);
        }
        if (currentPage === 1) {
            setDisablePre(true);
        }
        if (disableNext) {
            if (currentPage !== totalPages) {
                setDisableNext(false);
            }
        }
        else {
            if (currentPage === totalPages) {
                setDisableNext(true);
            }
        }
    }, [currentPage, disableNext, totalPages]);
    useEffect(() => {
        const element = [];
        for (let i = 0; i < totalPages; i++) {
            element.push(_jsx("option", { value: i + 1, children: t('whiteboard.page', { count: i + 1 }) }, i));
        }
        setOptions(element);
    }, [totalPages]);
    useEffect(() => {
        if (currentWhiteboardOfficeFileId !== previousFileId && isPresenter) {
            setTimeout(() => {
                if (excalidrawAPI) {
                    displaySavedPageData(excalidrawAPI, isPresenter, currentPage);
                }
            }, 500);
        }
    }, [currentWhiteboardOfficeFileId, previousFileId, currentPage]);
    const savePreviousPageData = () => {
        if (!excalidrawAPI) {
            return;
        }
        // for other user we'll clean from parent component
        // because from mobile or small screen pagination part remain collapse
        // no event will be run if this part don't show
        if (isPresenter) {
            if (previousPage) {
                savePageData(excalidrawAPI, previousPage);
            }
            cleanExcalidraw();
            displaySavedPageData(excalidrawAPI, isPresenter, currentPage);
        }
    };
    const cleanExcalidraw = () => {
        excalidrawAPI === null || excalidrawAPI === void 0 ? void 0 : excalidrawAPI.updateScene({
            elements: [],
        });
    };
    const setCurrentPage = (page) => {
        broadcastCurrentPageNumber(page);
        setTimeout(() => {
            dispatch(setWhiteboardCurrentPage(page));
        }, 500);
    };
    const handlePre = () => {
        setCurrentPage(currentPage - 1);
    };
    const handleNext = () => {
        setCurrentPage(currentPage + 1);
    };
    const renderForAdmin = () => {
        return (_jsxs("div", { className: "flex wb-page-navigation ml-2", children: [_jsx("button", { className: "pre w-8 h-8 flex items-center justify-center", onClick: handlePre, disabled: disablePre, children: _jsx("i", { className: "pnm-arrow-left-short text-black dark:text-white text-xl opacity-50 rtl:rotate-180" }) }), _jsx("select", { id: "pages", name: "pages", className: "pagesOpts block h-8 py-1 px-3 border border-gray-300 bg-white dark:bg-darkSecondary rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", onChange: (e) => setCurrentPage(Number(e.currentTarget.value)), value: currentPage, children: options }), _jsx("button", { className: "next w-8 h-8 flex items-center justify-center", onClick: handleNext, disabled: disableNext, children: _jsx("i", { className: "pnm-arrow-right-short text-black dark:text-white text-xl opacity-50 rtl:rotate-180" }) })] }));
    };
    const takeOverPresenter = async () => {
        const body = new SwitchPresenterReq({
            userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
            task: SwitchPresenterTask.PROMOTE,
        });
        const r = await sendAPIRequest('switchPresenter', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.presenter-changed'), {
                toastId: 'lock-setting-status',
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                toastId: 'lock-setting-status',
                type: 'error',
            });
        }
    };
    const renderForParticipant = () => {
        return (_jsxs("div", { className: `flex text-sm items-center justify-start md:justify-center relative ${isAdmin && !isRecorder
                ? 'ltr:pl-3 rtl:pr-3 md:pl-12  md:rtl:pr-4'
                : 'ltr:pl-3 rtl:pr-3'} `, children: [isAdmin && !isRecorder ? (_jsx("button", { className: "w-8 h-8 rounded-lg border border-solid border-[#3d3d3d] text-[#3d3d3d] dark:text-[#b8b8b8] dark:bg-[#262627] dark:hover:bg-[#3d3d3d] hover:bg-[#3d3d3d] hover:text-[#b8b8b8] flex items-center justify-center ltr:mr-2 rtl:ml-2", onClick: takeOverPresenter, children: _jsx("i", { className: "pnm-presenter text-[14px]" }) })) : null, t('whiteboard.page', { count: currentPage })] }));
    };
    return _jsx(_Fragment, { children: isPresenter ? renderForAdmin() : renderForParticipant() });
};
_react_refresh_temp_4 = FooterUI;
$RefreshReg$(_react_refresh_temp_4, "FooterUI");
_react_refresh_temp_6(FooterUI, "aGx58EfUECPR/FuoBlPcPjOf9UI=", false, () => [useAppSelector, useAppSelector, useAppSelector, usePreviousFileId, usePreviousPage, useAppDispatch, useTranslation]);
export default _react_refresh_temp_5 = React.memo(FooterUI);
$RefreshReg$(_react_refresh_temp_5, "%default%");
